import { render, staticRenderFns } from "./EnderecoForm.vue?vue&type=template&id=733c3ea0"
import script from "./EnderecoForm.vue?vue&type=script&lang=js"
export * from "./EnderecoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports